import client from "services/ngage/api-client";
import DataPage from "types/DataPage";
import {TicketType, TicketTypeData} from "types/TicketType";
import deserializeTicketType from "services/ngage/deserializers/ticket-type";
import {queryString} from "services/string";

/**
 * Get all ticket types (paginated)
 */
const all = async (page: number = 1, perPage: number = 100) => {
    const query = queryString({page, per_page: perPage})
    const response = await client.get<DataPage<TicketType> | null>(`/ticket-types?${query}`)

    if (response.data) {
        response.data.data = response.data.data.map(deserializeTicketType)
    }

    return response.data
}

/**
 * Get a single ticket type
 *
 * @param {number} id
 */
const get = async (id: number) => {
    return deserializeTicketType(
        (await client.get<TicketType>(`/ticket-types/${id}`)).data
    )
}

/**
 * Store a new ticket type
 *
 * @param data
 */
const store = async (data: TicketTypeData) => {
    return deserializeTicketType(
        (await client.post<TicketType>('/ticket-types', data)).data
    )
}

/**
 * Update an existing ticket type
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: TicketTypeData) => {
    return deserializeTicketType(
        (await client.put<TicketType>(`/ticket-types/${id}`, data)).data
    )
}

/**
 * Permanently delete an ticket type
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    return (await client.delete<null>(`/ticket-types/${id}`)).status === 204
}

const ticketTypes = {
    all,
    get,
    store,
    update,
    destroy
}

export default ticketTypes;